<section class="checks-container" [class.expanded]="expanded">
  <article class="card-inner big">
    <main
      role="button"
      tabindex="0"
      class="card-top"
      (click)="onExpandClicked()"
      [attr.aria-label]="getAriaLabel()"
      [attr.aria-expanded]="expanded">
      <div class="card-top-left" aria-hidden="true">
        <figure class="playlist-add-check-icon" [class.allChecksCompleted]="completedChecks === checklistItems.length">
          <i class="material-symbols-outlined check-icon">playlist_add_check</i>
        </figure>
        <h3 class="title text-truncate">
          {{ groupTitle }}
        </h3>
      </div>
      <div class="card-top-right" aria-hidden="true">
        <button
          type="button"
          class="card-button card-attachment-btn"
          *ngIf="totalAttachmentsCount > 0"
          (click)="onAttachmentsClicked($event)"
          tabindex="-1">
          <i class="material-symbols-outlined checklist-attachments-icon">attach_file</i>
          <span class="tiny-int" *ngIf="!isMobile">{{ totalAttachmentsCount }} {{ T.common.attached | translate }}</span>
          <span class="tiny-int" *ngIf="isMobile">{{ totalAttachmentsCount }}</span>
        </button>
        <output class="checks-complete"
          [class.allChecksCompleted]="completedChecks === checklistItems.length"
          [class.m-0]="expandAsDrawer">
          <ng-container *ngIf="!isMobile">
            {{
              T.common.count_slash_total_completed | translate: { count: completedChecks, total: checklistItems.length }
            }}
          </ng-container>
          <ng-container *ngIf="isMobile"> {{ completedChecks }}/{{ checklistItems.length }} </ng-container>
        </output>
        <span *ngIf="expandAsDrawer" class="d-flex">
          <i class="material-symbols-outlined">chevron_right</i>
        </span>
        <span *ngIf="!expandAsDrawer" class="arrow-down-icon" [style.transform]="expanded ? 'rotate(180deg)' : ''">
          <i class="material-symbols-outlined arrow-icon">expand_more</i>
        </span>
      </div>
    </main>
  </article>
  <article *ngIf="expanded" class="card-inner-expanded">
    <app-paginated-cards
      [paginationId]="paginationId"
      [items]="checklistItems"
      [trackByProperty]="'updated'"
      [cardTemplate]="cardTemplate"
      [draggable]="false"
      *ngIf="checklistItems.length"
      role="list"
      [attr.aria-label]="checklistItems.length + ' checklist items'"
    >
    </app-paginated-cards>
  </article>
</section>

<ng-template #cardTemplate let-item="item">
  <app-checklist-item-card
    [loading]="loading"
    style="width: 100%"
    [item]="item"
    [draggable]="draggable"
    [userHasWriteAccess]="canEdit"
    (itemCompleted)="updateItem($event)"
    role="listitem"
  >
  </app-checklist-item-card>
</ng-template>
